import { HOST_QUERY_NAME } from "../host/Host.constants.js";
const BASE_URL_FIELD = "_baseUrl";
const VERSION_FIELD = "_version";
const BRANCH_NAME_FIELD = "_branchName";
const USER_FIELD = "User";
const PREPROD_ENVIRONMENT = "_ppe";
const ENVIRONMENT_FIELD = "_env";
const BOOTSTRAP_PREFIX = "bst.";
const BST_ENABLE_MSAL_TESTING = `${BOOTSTRAP_PREFIX}enableMsalTesting`;
const BST_CUSTOM_BUILD = `${BOOTSTRAP_PREFIX}customBuild`;
const BST_CDN_ASSETS_VERSION = `${BOOTSTRAP_PREFIX}CdnAssetsVersion`;
const SET_TREATMENT_VARIABLE = "_treatmentVariable";
const PORTAL_EXPERIENCE = "experience";
var PORTAL_EXPERIENCES = /* @__PURE__ */ ((PORTAL_EXPERIENCES2) => {
  PORTAL_EXPERIENCES2["studio"] = "studio";
  PORTAL_EXPERIENCES2["ct"] = "ct";
  return PORTAL_EXPERIENCES2;
})(PORTAL_EXPERIENCES || {});
const WORKSPACE_ID = "workspaceId";
const TENANT_ID = "tid";
const GROUP_ID = "group";
const MANAGEMENT_GROUP = "managementGroup";
const RETURN_URL = "return-url";
const NO_CHROME = "nochrome";
const NEW_PREVIEW_SCORECARD_DRI_BYPASS = "newPreviewScorecardDriBypass";
const TREATMENT_FIELD = "treatment";
const CONTROL_FIELD = "control";
const PRIMARY_SEGMENT_NAME_FIELD = "primarySegmentName";
const PRIMARY_SEGMENT_VALUE_FIELD = "primarySegmentValue";
const ANALYSIS_CREATE_QUERY = {
  METRIC_SET_NAME: "metricSetName",
  METRIC_SET_VERSION_ID: "metricSetVersionId",
  METRIC_SET_VERSION_NAME: "metricSetVersionName"
};
const EXP_QUERY_STRINGS = [
  BASE_URL_FIELD,
  VERSION_FIELD,
  BRANCH_NAME_FIELD,
  USER_FIELD,
  HOST_QUERY_NAME,
  PREPROD_ENVIRONMENT,
  ENVIRONMENT_FIELD,
  // Treatment Variables
  SET_TREATMENT_VARIABLE,
  WORKSPACE_ID,
  /**
   * TODO - consider deprecating tid from global query params if we do not want to support including this
   */
  TENANT_ID,
  GROUP_ID,
  RETURN_URL,
  NEW_PREVIEW_SCORECARD_DRI_BYPASS,
  BST_CDN_ASSETS_VERSION
];
export {
  ANALYSIS_CREATE_QUERY,
  BASE_URL_FIELD,
  BOOTSTRAP_PREFIX,
  BRANCH_NAME_FIELD,
  BST_CDN_ASSETS_VERSION,
  BST_CUSTOM_BUILD,
  BST_ENABLE_MSAL_TESTING,
  CONTROL_FIELD,
  ENVIRONMENT_FIELD,
  EXP_QUERY_STRINGS,
  GROUP_ID,
  MANAGEMENT_GROUP,
  NEW_PREVIEW_SCORECARD_DRI_BYPASS,
  NO_CHROME,
  PORTAL_EXPERIENCE,
  PORTAL_EXPERIENCES,
  PREPROD_ENVIRONMENT,
  PRIMARY_SEGMENT_NAME_FIELD,
  PRIMARY_SEGMENT_VALUE_FIELD,
  RETURN_URL,
  SET_TREATMENT_VARIABLE,
  TENANT_ID,
  TREATMENT_FIELD,
  USER_FIELD,
  VERSION_FIELD,
  WORKSPACE_ID
};
//# sourceMappingURL=QueryString.constants.js.map
